// REACT E HOOKS
import React, { useCallback, useEffect, useState, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';

// MATERIAL UI
import {
  Box,
  ButtonBase,
  IconButton,
  Container,
  Typography,
  Chip,
  Drawer,
  CircularProgress,
  List,
  Paper,
} from '@material-ui/core';

// DADOS E SERVIÇOS
import { LatLngBoundsLiteral, LatLngTuple } from 'leaflet';
import {
  mapInformationChartDataObject,
} from '../../@types/chartData';
import { optionStyles } from './styles';

import { jsonb as JsonbType } from '../../@types/jsonb';
import { EducFilterOpsType } from '../../@types/educationTypes';

// COMPONENTS
import LeftArrow from '../../assets/leftArrow.svg';
import MapContent, { DrawPolygonType } from '../../components/MapContent';
import FilterBar from '../../components/FilterBar';
import { getFilterDates } from '../../actions/managementActions';
import { fetchEducationsTileKey, getEducationInformationChartData } from '../../actions/educationActions';

// INTERFACES
interface ResponseManagement {
  uuid: string;
  datetime_begin: string;
  datetime_end: string;
  datetime_map_begin: string;
  datetime_map_end: string;
}

const initialJsonb: JsonbType = {
  jsonb: {
    educationMission: {
      focoDaMissao: {
        contains: [],
        _rule_type: 'containment',
      },
      tipoDaMissao: {
        contains: [],
        _rule_type: 'containment',
      },
    },
  },
};

const initialFilterOps: EducFilterOpsType = {
  endDate: '',
  startDate: '',
  bairros: '',
  focoDaMissao: [],
  tipoDaMissao: [],
  drawPolygon: {},
};

// CONSTANTES
const loadFilterOps = (): EducFilterOpsType => {
  let filterOpsObj: EducFilterOpsType = initialFilterOps;
  // obtendo o valor armazenado
  const loadedFilterOps = localStorage.getItem('educFilterOps');

  if (loadedFilterOps) {
    filterOpsObj = JSON.parse(loadedFilterOps);
  }

  return filterOpsObj;
};

const loadJsonbStorage = (): JsonbType => {
  const loadedFilterOps = localStorage.getItem('educFilterOps');
  let jsonbObj: JsonbType = initialJsonb;

  if (loadedFilterOps) {
    const parsedFilters: EducFilterOpsType = JSON.parse(loadedFilterOps);

    const vehicles: Array<string | string[]> = [];
    const gravity: Array<string | string[]> = [];

    parsedFilters.tipoDaMissao.map((item) => {
      vehicles.push(item);
      vehicles.push([item]);
    });

    parsedFilters.focoDaMissao.map((item) => {
      gravity.push(item);
      gravity.push([item]);
    });

    jsonbObj = {
      jsonb: {
        educationMission: {
          focoDaMissao: {
            contains: vehicles,
            _rule_type: 'containment',
          },
          tipoDaMissao: {
            contains: gravity,
            _rule_type: 'containment',
          },
        },
      },
    };
    return jsonbObj;
  }
  return jsonbObj;
};

// ----MAP EDUCATION----
const MapEducation: React.FC = () => {
  // CONSTANTE
  const filterOps: EducFilterOpsType = loadFilterOps();

  // ESTADOS BOOLEANOS
  const [admin, setAdmin] = useState<boolean>(false);
  const [education, setEducation] = useState<boolean>(false);
  const [geofi, setGeofi] = useState<boolean>(false);
  const [loadingDrawerInformation, setLoadingDrawerInformation] = useState<boolean>(false);
  const [loadingDate, setloadingDate] = useState<boolean>(true);
  const [openTable, setOpenTable] = useState<boolean>(true);
  const [openTableResp, setOpenTableResp] = useState<boolean>(false);
  const [publicGroup, setPublicGroup] = useState<boolean>(false);
  const [tecEng, setTecEng] = useState<boolean>(false);
  const [typist, setTypist] = useState<boolean>(false);

  const defaultStartDate = `${process.env.REACT_APP_MAP_START_DEFAULT_DATE}`;
  const defaultEndDate = `${process.env.REACT_APP_MAP_END_DEFAULT_DATE}`;
  const [dateMin, setDateMin] = useState<string>(defaultStartDate);
  const [dateMax, setDateMax] = useState<string>(defaultEndDate);

  // ESTADOS DE OBJETO
  const [bboxPolygon, setBboxPolygon] = useState<LatLngBoundsLiteral>([
    [0, 0],
    [0, 0],
  ]);
  const [boundary_polygon, setBoundary_polygon] = useState<{}>({
    polygon_id: loadFilterOps().bairros,
  });

  const [drawPolygon, setDrawPolygon] = useState<DrawPolygonType | {}>(
    loadFilterOps().drawPolygon,
  );

  const [jsonb, setJsonb] = useState<JsonbType>(loadJsonbStorage());
  const [mapInformationChart, setMapInformationChart] = useState<
    mapInformationChartDataObject[]
  >([]);

  const params = useMemo(() => {
    return {
      record_type: `${process.env.REACT_APP_EDUCATION_RECORD_TYPE}`,
      occurred_min: filterOps?.startDate || dateMin,
      occurred_max: filterOps?.endDate || dateMax,
      ...jsonb,
      ...drawPolygon,
      ...boundary_polygon,
    };
  }, [
    drawPolygon,
    boundary_polygon,
    jsonb,
    dateMin,
    dateMax,
    filterOps.startDate,
    filterOps.endDate,
  ]);

  // ESTADO NUMÉRICOS
  const [openMenu, setOpenMenu] = useState<number>(0);
  const [zoom, setZoom] = useState<number>(0);

  // ESTADOS DE FUNÇÃO
  const dispatch = useDispatch();
  const history = useHistory();

  // ESTADO DE ESTILO
  const classes = optionStyles();

  // DATAS
  const [startDateMap, setStartDateMap] = useState<string>('2014-01-01T00:00:00Z');
  const [endDateMap, setEndDateMap] = useState<string>('2020-06-30T23:59:59.999000Z');

  const [address, setAddress] = useState<string>('');
  const [requester, setRequester] = useState<string>('');
  const [position, setPosition] = React.useState<LatLngTuple>([0, 0]);

  // Definir o estado inicial com base nos grupos de usuário salvos no localStorage
  useEffect(() => {
    const groups = localStorage.getItem('groups')?.split(' ');
    if (groups) {
      groups.forEach((gr: string) => {
        if (gr === 'public') {
          setPublicGroup(true);
        } else if (gr === 'digitador') {
          setTypist(true);
        } else if (gr === 'tec_engenharia') {
          setTecEng(true);
        } else if (gr === 'geofi') {
          setGeofi(true);
        } else if (gr === 'educacao') {
          setEducation(true);
        } else if (gr === 'admin') {
          setAdmin(true);
        }
      });
    }
  }, []);

  if ((publicGroup || tecEng || typist || geofi) && !(admin || education)) {
    history.push('/mapa/educacao');
  }

  // Realizar chamadas de API para obter informações e atualizar o estado
  const fetchMapInformationChartData = useCallback(async () => {
    setLoadingDrawerInformation(true);
    try {
      const { data } = await getEducationInformationChartData({
        params
      })
      setMapInformationChart(data);
    } catch (error) {
      console.log(error)
      setMapInformationChart([]);
    } finally {
      setLoadingDrawerInformation(false);
    }
  }, [params]);
  const fetchManagementDate = useCallback(async () => {
    setloadingDate(true);
    try {
      const dates = await getFilterDates(filterOps.startDate, filterOps.endDate);
      setDateMin(dates.dateMin);
      setDateMax(dates.dateMax);
      setStartDateMap(dates.startDateMap);
      setEndDateMap(dates.endDateMap);
    } catch (error) {
      console.log(error);
    } finally {
      setloadingDate(false);
    }

  }, [filterOps.startDate, filterOps.endDate]);

  // USEEFFECT
  useEffect(() => {
    fetchManagementDate();
  }, [fetchManagementDate]);

  useEffect(() => {
    if (!loadingDate) {
      fetchMapInformationChartData();
    }
  }, [loadingDate, fetchMapInformationChartData]);

  return (
    <>
      {/* FILTRO */}
      <FilterBar
        filterJson={setJsonb}
        dateMinSet={setDateMin}
        dateMaxSet={setDateMax}
        setPositionSearch={setPosition}
        zoom={setZoom}
        id_boundary={setBoundary_polygon}
        bbox_boundary={setBboxPolygon}
        routeTo="educ"
        startDateMap={startDateMap}
        endDateMap={endDateMap}
        drawPolygon={drawPolygon}
        setDrawPolygon={setDrawPolygon}
        address={address}
        setAddress={setAddress}
        requester={requester}
        setRequester={setRequester}
      />

      {/* FOOTER DO MAPA */}
      <Container className={classes.responsiveButton}>
        <Chip
          title="Fiscalizações"
          label="Fiscalizações"
          className={classes.pageNameChip}
        />
        <ButtonBase
          className={classes.responsivemenuButton}
          onClick={() => {
            setOpenMenu(openMenu === 1 ? 0 : 1);
          }}
        >
          Gráficos
        </ButtonBase>
        <ButtonBase
          className={classes.responsivemenuButton}
          onClick={() => setOpenMenu(openMenu === 2 ? 0 : 2)}
        >
          Exportar
        </ButtonBase>

        <ButtonBase
          onClick={() => {
            openTableResp ? setOpenTableResp(false) : setOpenTableResp(true);
          }}
          className={`${classes.responsivemenuButton} ${
            openTableResp ? classes.tableOpen : classes.tableClosed
          }`}
        >
          <img
            className={classes.tableButonIcon}
            src={LeftArrow}
            alt="Right"
            style={{ transform: `${openTableResp ? 'rotate(0deg)' : 'rotate(180deg)'}` }}
          />
          {openTableResp ? (
            <>
              <Typography variant="h6" className={classes.tableText}>
                Fechar aba lateral
              </Typography>
            </>
          ) : (
            <>
              <Typography variant="h6" className={classes.tableText}>
                Abrir aba lateral
              </Typography>
            </>
          )}
        </ButtonBase>
      </Container>

      {/* MAPA */}
      <div>
        <MapContent
          pageName="Educação"
          occurred_min={dateMin}
          occurred_max={dateMax}
          jsonb={jsonb}
          polygon={setDrawPolygon}
          positionSearch={position}
          zoomSearch={zoom}
          polygon_id={boundary_polygon}
          bbox={bboxPolygon}
          type={`${process.env.REACT_APP_EDUCATION_RECORD_TYPE}`}
          apiName="educacao"
          registerName="Ações"
          loadingMap={loadingDate}
          config={{params}}
          fetchTileKeyRequest={fetchEducationsTileKey}
        />
      </div>

      <>
        {/* Seta para recolher informação lateral */}
        <Box
          className={`${classes.tableButton} ${
            openTable ? classes.tableOpen : classes.tableClosed
          }`}
        >
          <IconButton
            className={classes.button}
            onClick={() => (openTable ? setOpenTable(false) : setOpenTable(true))}
          >
            <img className={classes.tableButonIcon} src={LeftArrow} alt="Right" />
          </IconButton>
        </Box>

        {/* INFORMAÇÃO LATERAL */}
        <Drawer
          anchor="right"
          open={openTable}
          variant="persistent"
          ModalProps={{ BackdropProps: { invisible: true } }}
          PaperProps={{ className: classes.tableDrawer }}
        >
          {loadingDrawerInformation ? (
            <div className={classes.loadingContainer}>
              <CircularProgress
                className={classes.loadingSpinner}
                size={60}
                thickness={5}
              />
            </div>
          ) : (
            <List>
              {mapInformationChart.map((obj) => (
                <Paper className={classes.accidentCard} key={`${obj.label} ${obj.value}`}>
                  <Box className={classes.accidentLabel}>{obj.label}</Box>
                  <Box className={classes.accidentValue}>{obj.value.toLocaleString('pt-BR')}</Box>
                </Paper>
              ))}
            </List>
          )}
        </Drawer>

        <Drawer
          anchor="right"
          open={openTableResp}
          variant="persistent"
          ModalProps={{ BackdropProps: { invisible: true } }}
          PaperProps={{ className: classes.tableDrawerResp }}
        >
          {!loadingDrawerInformation ? (
            <div className={classes.loadingContainer}>
              <CircularProgress
                className={classes.loadingSpinner}
                size={60}
                thickness={5}
              />
            </div>
          ) : (
            <List>
              {mapInformationChart.map((obj) => (
                <Paper className={classes.accidentCard} key={`${obj.label} ${obj.value}`}>
                  <Box className={classes.accidentLabel}>{obj.label}</Box>
                  <Box className={classes.accidentValue}>{obj.value}</Box>
                </Paper>
              ))}
            </List>
          )}
        </Drawer>
      </>

      
    </>
  );
};

export default MapEducation;
